<template>
  <div class="dialogs" v-show="maskShow">
    <p class="tip">鉴于钉钉设计原因, 提交后，您的历史账号及关联的相关文件、群聊信息可能会丢失。</p>
    <button class="btn" @click="confirm()">我知道了</button>
  </div>
</template>

<script>
export default {
  props: ["maskShow", "employeeCode", "currentPhone"],
  data() {
    return {};
  },
  methods: {
    confirm() {
      var params = {
        employeeCode: this.employeeCode,
        phone: this.currentPhone
      };
      this.$api
        .phoneUpdate(params)
        .then(res => {
          console.log(res.data);
          this.$router.push("/download");
        })
        .catch(res => {
          console.log(res)
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialogs {
  width: 6.38rem;
  height: 2.61rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.08rem;
  position: relative;
  z-index: 10;
  padding: 0.4rem 0.4rem 0rem 0.4rem;
  margin: -2rem auto;
  .tip {
    height: 0.8rem;
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: left;
  }
  .btn {
    position: absolute;
    width: 100%;
    height: 1rem;
    background: rgba(255, 255, 255, 1);
    bottom: 0;
    left: 0;
    border: 0;
    outline: none;
    border-bottom-left-radius: 0.08rem;
    border-bottom-right-radius: 0.08rem;
    font-size: 0.34rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(50, 150, 250, 1);
    line-height: 0.48rem;
    border-top: 0.02rem solid rgba(221, 221, 221, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/tips.vue